/**
 * Switches for decorative effects, so a decision to bring one back is a
 * one-word change rather than a search through the components.
 *
 * GLOW_ENABLED: the soft light that follows the pointer across the hero (HeroGlow)
 * and behind the public header (PageGlow). Switched off 2026-10-16, because on
 * dark backgrounds it read as a smudge of light in the corner. The components
 * are untouched; set this to true to bring both back.
 */
export const GLOW_ENABLED = false;
